import { useEffect, useState } from "react";
import {
  getSiteLanguage,
  subscribeSiteLanguage,
  type SiteLanguageCode,
} from "@/lib/language";

/** Subscribe to header language switcher (same bus as the chatbot). */
export function useSiteLanguage(): SiteLanguageCode {
  const [lang, setLang] = useState<SiteLanguageCode>(() => getSiteLanguage());

  useEffect(() => subscribeSiteLanguage(setLang), []);

  useEffect(() => {
    try {
      document.documentElement.lang = lang;
    } catch {
      /* ignore */
    }
  }, [lang]);

  return lang;
}
